import { memo } from 'react'

import { _TProduct } from '@/shared/types/deprecated-types'
import { OrderType } from '@/shared/types/product-types'
import { CountField } from '@/shared/ui/CountField/CountField'

import styles from './basket-item-table.module.scss'

type QuantityControlProps = {
	orderType: _TProduct['ORDER_TYPE']
	initialCount: number
	onCountChange: (quantity: number) => void
}

/**
 * Компонент управления количеством товара
 */
export const QuantityControl = memo(({ orderType, initialCount, onCountChange }: QuantityControlProps) => {
	const isHiddenBuy = orderType === OrderType.HideBuy

	return (
		<div className={styles.quantityCell}>
			{isHiddenBuy ? (
				`Нет в наличии`
			) : (
				<div className={styles.countFieldWrap}>
					<CountField countChangeHandler={onCountChange} initialCount={initialCount} withoutRemovable />
				</div>
			)}
		</div>
	)
})
